export default function CampaignBenefits() {
  const benefits = [
    {
      icon: 'ri-price-tag-3-line',
      title: '現行価格を維持',
      description: '2026年3月1日からの価格改定前の特別価格でご購入いただけます。',
    },
    {
      icon: 'ri-gift-line',
      title: 'Amazonギフト券5,000円',
      description: 'ご予約いただいた方全員に、Amazonギフト券5,000円分をプレゼント。',
    },
    {
      icon: 'ri-calendar-check-line',
      title: '4月の次回入荷まで有効',
      description: '3月31日までのご予約で、4月の次回入荷分まで現行価格が適用されます。',
    },
    {
      icon: 'ri-customer-service-line',
      title: '優先サポート',
      description: 'キャンペーン期間中のご予約者様には、優先的にサポート対応いたします。',
    },
  ];

  return (
    <section className="py-20 sm:py-28 bg-[#FAFAF8]" aria-labelledby="campaign-benefits-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <h2 id="campaign-benefits-heading" className="text-2xl sm:text-3xl md:text-4xl font-extralight text-black mb-4 tracking-[0.08em]">
            キャンペーン特典
          </h2>
          <p className="text-sm sm:text-base font-extralight text-black/50 tracking-wide max-w-2xl mx-auto">
            3月31日までのご予約で、以下の特典をすべてお受け取りいただけます。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-6 sm:p-8 border border-black/5 hover:border-[#C4787A]/20 transition-all hover:shadow-sm"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#C4787A]/10 rounded-full mb-5">
                <i className={`${benefit.icon} text-xl text-[#C4787A]`} aria-hidden="true"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-light text-black mb-3 tracking-wide">
                {benefit.title}
              </h3>
              <p className="text-sm font-extralight text-black/60 leading-relaxed tracking-wide">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
